import React, {useContext, useEffect, useState} from 'react'
import {Checkbox, FormControlLabel} from '@mui/material'
import {titleColor} from '../../../../metrics.module.scss'
import {ItemBagContext} from '../../../../context/ItemBagContext.jsx'
import {clearText, isEmpty} from 'react-lf-tools'

const StepObservations = ({title, options, step, stepIndex}) => {
    const {observations, setObservations, isEdit, item} = useContext(ItemBagContext)
    const [items, setItems] = useState({})
    const handleChange = (checked, option) => {
        const array = observations
        option.amount = 1
        option.step = step
        option.stepIndex = stepIndex
        setItems({...items, [option.sku]: checked ? option.sku : ''})
        if (checked) {
            if (!isEmpty(array[stepIndex])) {
                array[stepIndex].push(option)
            } else {
                array[stepIndex] = [option]
            }
            setObservations(array)
        } else {
            const index = array[stepIndex].findIndex((observation) => (observation.sku === option.sku))
            array[stepIndex].splice(index, 1)
            setObservations(array)
        }
    }
    const checkObservations = () => {
        if (isEdit) {
            findObservationsBySku(options, item)
        }
    }
    const findObservationsBySku = (options, item) => {
        for (const s in item.subitems) {
            for (const o in options) {
                if (item.subitems[s].sku === options[o].sku) {
                    addObservations(item.subitems[s])
                }
            }
        }
    }
    const addObservations = (option) => {
        option.step = step
        option.stepIndex = stepIndex
        items[option.sku] = option.sku
        const array = observations
        if (!isEmpty(array[stepIndex])) {
            array[stepIndex].push(option)
        } else {
            array[stepIndex] = [option]
        }
        setObservations(array)
        setItems({...items})
    }
    useEffect(() => {
        checkObservations()
    }, [])
    return <div className={'step-observations'}>
        <div className={'card-step'} id={`step${step}`}>
            <div className={'div-title-step'}>
                <label className={'label-title-step'}>
                    {title}
                </label>
            </div>
            <div className={'div-items-step'}>
                {options.map(option => <div className={'div-description-step'} key={option.option}
                                            id={clearText(option.option)}>
                    <div className={'div-description-price-step'}>
                        <FormControlLabel
                            sx={{'& .MuiTypography-root': {fontFamily: 'Nunito'}}}
                            checked={(option.sku === items[option.sku])}
                            onChange={(event, checked) => handleChange(checked, option)}
                            control={<Checkbox style={{color: titleColor}}/>}
                            label={option.option}/>
                    </div>
                </div>)}
            </div>
        </div>
    </div>
}

export default StepObservations
